import { render, staticRenderFns } from "./changeTheOriginOfTheProductModal.vue?vue&type=template&id=6daa1b7d"
import script from "./changeTheOriginOfTheProductModal.vue?vue&type=script&lang=js"
export * from "./changeTheOriginOfTheProductModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports